import { render, staticRenderFns } from "./articleTeaser.vue?vue&type=template&id=729b1fdd&"
var script = {}
import style0 from "./articleTeaser.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729b1fdd')) {
      api.createRecord('729b1fdd', component.options)
    } else {
      api.reload('729b1fdd', component.options)
    }
    module.hot.accept("./articleTeaser.vue?vue&type=template&id=729b1fdd&", function () {
      api.rerender('729b1fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/articleTeaser/articleTeaser.vue"
export default component.exports